import React from 'react';
import useStyles from './styles';
const logo = require("./images/Flyt Logo.svg");
export default function FlytLogo() {
  const {
    flytLogo
  } = useStyles();
  return /*#__PURE__*/React.createElement("img", {
    className: flytLogo,
    src: logo
  });
}